require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-branches-closed-on-monday-october-11.json") })
        }
      }, "path---es-articles-branches-closed-on-monday-october-11");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-branches-closed-on-monday-october-11!./.cache/json/es-articles-branches-closed-on-monday-october-11.json
// module id = 2070
// module chunks = 231608221292675